import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
const TONE = {
    success: "bg-success-soft text-success",
    warning: "bg-warning-soft text-warning",
    danger: "bg-danger-soft text-danger",
    info: "bg-info-soft text-info",
    neutral: "bg-ink-100 text-ink-700",
    olive: "bg-accent-soft text-accent-deep",
};
export function StatusPill({ tone = "neutral", className, children, ...rest }) {
    return (_jsxs("span", { "data-slot": "status-pill", "data-tone": tone, className: cn("inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-overline font-semibold uppercase tracking-[0.014em]", TONE[tone], className), ...rest, children: [_jsx("span", { "aria-hidden": true, className: "inline-block h-1.5 w-1.5 rounded-pill bg-current" }), children] }));
}
